import React, { Fragment } from 'react';
import { getSubChannels, isParent, isRootChannel } from 'utils/common';
import { SubMenuHeader } from './sub-menu-header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

export const ChannelList = ({ channelId, navigationChannels, rootChannels, changeId, resetId, goToChannel }) => {
  let channels = rootChannels;
  let channel;
  if (channelId) {
    channel = navigationChannels.find((channel) => {
      return channelId === channel.id;
    });
    if (channel && isParent(navigationChannels, channel)) {
      channels = getSubChannels(navigationChannels, channel);
    }
  }
  return (
    <Fragment>
      <SubMenuHeader channel={channel} channelId={channelId} goToChannel={goToChannel} changeId={changeId} />
      <ul className="ct-mobile-menu__list" data-e2e="mobile-menu-list">
        {channels.map((channel) => {
          const isActive = window.location.pathname !== '/my-videos' && channel.active;

          let elementClass = isRootChannel(channel) ? `ct-mobile-menu__list-root-elem` : 'ct-mobile-menu__list-elem';

          if (isActive) {
            elementClass += isRootChannel(channel)
              ? ' ct-mobile-menu__list-root-elem--active'
              : ' ct-mobile-menu__list-elem--active';
          }

          if (isParent(navigationChannels, channel) && channel.parentId !== null) {
            return (
              <li
                key={channel.id}
                className={`${elementClass} ct-mobile-menu__list-elem`}
                aria-current={isActive ? 'page' : undefined}
              >
                <button
                  onClick={() => changeId(channel.id)}
                  className={` ct-mobile-menu__button`}
                  data-e2e={`mobile-nav-item-wrapper-${channel.id}`}
                >
                  {channel.title}

                  <FontAwesomeIcon icon={faAngleRight} aria-hidden="true" />
                </button>
              </li>
            );
          } else {
            return (
              <li key={channel.id}>
                <button
                  onClick={() => resetId(channel.url)}
                  data-e2e={`mobile-nav-item-${channel.id}`}
                  className={`${elementClass} ct-mobile-menu__button`}
                >
                  {channel.title}
                </button>
              </li>
            );
          }
        })}
      </ul>
    </Fragment>
  );
};
